// import React from 'react';
// import Footer from '../../components/footer'
// import Scrollbar from '../../components/scrollbar'
// import './App.css';
// import AllRoute from '../router';


// const App = () => { 

//   return (
//     <div className="App">
//         <AllRoute/>
//         <Footer/>
//         <Scrollbar/>
//     </div>
//   );
// }

// export default App;
import React, { useState } from 'react';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import './App.css';
import AllRoute from '../router';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const correctPassword = 'Pretoria#2024';

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInput === correctPassword) {
      setIsAuthenticated(true);
    } else {
      alert('Incorrect password');
      setPasswordInput('');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="password-overlay">
        <form onSubmit={handlePasswordSubmit} className="password-form">
          <h2>Enter Password</h2>
          <input
            type="password"
            value={passwordInput}
            onChange={(e) => setPasswordInput(e.target.value)}
            placeholder="Enter password"
            required
          />
          <button type="submit">Enter</button>
        </form>
      </div>
    );
  }

  return (
    <div className="App">
      <AllRoute />
      <Footer />
      <Scrollbar />
    </div>
  );
};

export default App;

